import { FETCH_SCREENSHOTS, UPDATE_SCREENSHOTS } from 'constants/actions';

const DEFAULT_STATE = {
  screenshots: [],
  isFetchingScreenshots: false,
  hasFetchedScreenshots: false,
};

const screenshotsDashboardReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_SCREENSHOTS:
      return {
        ...state,
        error: null,
        isFetchingScreenshots: true,
      };
    case UPDATE_SCREENSHOTS:
      return {
        ...state,
        hasFetchedScreenshots: true,
        isFetchingScreenshots: false,
        screenshots: action.screenshots || DEFAULT_STATE.screenshots,
      };
    default:
      return state;
  }
};

export default screenshotsDashboardReducer;
